import React, { createContext, Dispatch } from 'react'
import { ColumnActions, ColumnActionTypes } from './types'

// COMPONENTS
import Button from '../../../atoms/button'


export type BtnProps = (React.ComponentPropsWithRef<typeof Button> & { innerText: string }) | null
export interface ColumnState {
    btnProps: [BtnProps, BtnProps],
    /** Time in milliseconds */
    transitionTime: number
}

export const initState: ColumnState = {
    btnProps: [null, null],
    transitionTime: 400,
}

export function ColumnReducer(state = initState, action: ColumnActionTypes): ColumnState {
    switch (action.type) {
        case ColumnActions.SET_BUTTON_PROPS: return { ...state, btnProps: action.payload }
        default: return state
    }
}

export const ColumnContext = createContext<{ localState: ColumnState, localDispatch: Dispatch<ColumnActionTypes> }>({
    localState: initState,
    localDispatch: () => undefined,
})